<a
  *ngIf="!disableSort; else noSort"
  (click)="sortBy(field)"
  title="{{ 'nouns.orderBy' | translate }} {{ label | translate }}"
>
  <span>{{ label | translate }}</span>
  <span class="glicon-order" [ngClass]="order"></span>
</a>
<ng-template #noSort>
  <span title="{{ 'nouns.orderBy' | translate }} {{ label | translate }}">{{ label | translate }}</span>
</ng-template>
<ng-content></ng-content>
